import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAudioVolume = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.5 7.69887C13.5 5.31922 10.8274 3.91888 8.87083 5.2734L6.21128 7.11463C6.05173 7.22509 5.86865 7.29688 5.67654 7.32433L4.36109 7.51225C3.00631 7.70579 2 8.86607 2 10.2346V13.7654C2 15.134 3.0063 16.2943 4.36109 16.4878L5.67654 16.6757C5.86865 16.7032 6.05173 16.775 6.21128 16.8854L8.87083 18.7266C10.8274 20.0812 13.5 18.6808 13.5 16.3012V7.69887ZM9.72465 6.50669C10.6863 5.84091 12 6.52921 12 7.69887V16.3012C12 17.4708 10.6863 18.1591 9.72465 17.4933L7.06509 15.6521C6.71408 15.4091 6.31131 15.2512 5.88868 15.1908L4.57322 15.0029C3.95741 14.9149 3.5 14.3875 3.5 13.7654V10.2346C3.5 9.61255 3.95741 9.08515 4.57322 8.99717L5.88868 8.80925C6.31131 8.74888 6.71408 8.59093 7.06509 8.34792L9.72465 6.50669Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.956 18.6964C19.087 18.7874 19.236 18.8314 19.384 18.8314C19.621 18.8314 19.854 18.7194 20 18.5104C22.713 14.6094 22.713 9.3664 20 5.4624C19.763 5.1214 19.297 5.0364 18.957 5.2734C18.616 5.5104 18.532 5.9774 18.769 6.3174C21.162 9.7634 21.162 14.2124 18.769 17.6524C18.532 17.9934 18.616 18.4604 18.956 18.6964Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.881 16.4223C16.754 16.4223 16.626 16.3903 16.508 16.3223C16.149 16.1163 16.025 15.6573 16.231 15.2993C17.402 13.2583 17.402 10.7203 16.231 8.67332C16.025 8.31332 16.15 7.85532 16.509 7.64932C16.869 7.44732 17.326 7.56832 17.532 7.92732C18.967 10.4353 18.967 13.5453 17.532 16.0453C17.393 16.2873 17.141 16.4223 16.881 16.4223Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconAudioVolume as ReactComponent };
